<template>
    <div class="inner-wrapper">
   <!--<div class="page-title">
      <h1 class="float-left">Customers</h1>
      <div class="title-right float-right">

      </div>
   </div>-->
      <div class="new-rfq">
      <fieldset class="customer-search mb-3">
               <div class="row">
                    <div class="col-sm-6 col-md-6">
                        <div class="form-inline" action="">
                            
                            


                        </div>
                    </div>
                    <div class="col-sm-6 col-md-6">
                        <div class="btnrow float-right">
                        
                         <button type="button" class="btn create-btn" data-toggle="modal" data-target="#customerAddModal">
                             Add Warehouse
                        </button>
                        <!-- <router-link :to="{ name: 'addCustomer'}" class="btn create-btn">
                            <i class="fa fa-plus" aria-hidden="true"></i> Create Customer
                            </router-link> -->
                        </div>
                    </div>
               </div>
            </fieldset>

            <!-- The Modal -->

        <div class="row">

            <div class="col-lg-12 col-md-12">
                <div class="card panel customer-list-sec">
                    <div class="card-header headnbtn">
                        <div class="d-flex align-items-center ">
                            <h5 class="card-title mb-0 flex-grow-2">List of Warehouse</h5>
                            
                        </div>
                    </div>

                    <div class="card-body">
                        <div class="table-responsive product-create table-card mb-0">
                           

                            <table class="table table-custom table-nowrap table-bordered align-middle mb-0">
                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    
                                    <th>Name</th>
                                    <!-- <th>Description</th> -->
                                    <th>Address</th>
                                    <th>Address 2</th>
                                    <th>City</th>
                                    <th>Post Code</th>
                                    <th>State</th>
                                    <th style="width: 100px">Action </th>

                                </tr>
                            </thead>
                            <template v-for="(customer, index) in customerData.customers.data">
                                <tr :id="customer.id">
                                    <td>{{ getSLNo(index)}}</td>
                                   
                                    <td>{{  customer.name }}</td>
                                    
                                    <!-- <td>{{ customer.description}}</td> -->
                                    <td>{{ customer.address }}</td>
                                    <td>{{ customer.address2 }}</td>
                                    <td>{{ customer.city }}</td>
                                    <td>{{ customer.post_code }}</td>
                                    <td>{{ customer.state }}</td>
                                    
                                    <td>
                                        <router-link 
                                                 :to="{name: 'editWarehouse', params: {id: customer.id}}"
                                                 class="edit_btn" title="Edit Customer" :data-id="customer.id"><i class="ri-edit-fill me-1"></i></router-link>
                                        <a v-if="customerData.can_delete_customer" href="javascript:void(0);" @click="showDelete(customer.id)" class="del_btn" title="Delete Customer" :data-id="customer.id"><i class="ri-delete-bin-6-line"></i></a>
                                    </td>
                                </tr>
                            </template>
                            </table>
                        </div>

                    </div>

                    <div class="btnrow text-left mb-3">
                        <template>
                        <div class="overflow-auto">
                            <b-pagination
                            v-model="current_page"
                            :total-rows="total"
                            :per-page="per_page"
                            ></b-pagination>

                            <!-- <p class="mt-3">Current Page: {{ current_page }}</p> -->


                        </div>
                        </template>
                    </div>
                </div>


            </div>
        </div>


            
      </div>

      <!-- Delete Modal HTML -->
    <div id="deleteModal" class="modal fade delete-modal">
        <div class="modal-dialog modal-confirm">
            <div class="modal-content">
                <div class="modal-header">
                   
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true"><i class="ri-close-line"></i></button>
                </div>
                <div class="modal-body text-center">
                   <div class="trashbtn"><i class="ri-delete-bin-6-line"></i></div>
                    <h4 class="inr-title">Are you sure?</h4>
                    <p>Do you really want to delete these records? This process cannot be undone.</p>

                    <div class="btnrow">
                        <button type="button" class="btn btn-primary  me-1" data-dismiss="modal">Cancel</button>
                        <button type="button" class="btn btn-danger confirm_delete" @click="deleteCustomer()">Delete</button>
                    </div>
                </div>
                <input type="hidden" name="delete_id" id="delete_id" value="">
                
            </div>
        </div>
    </div>

   <footer class="footer">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-sm-6">
                        2022 © Superb.
                    </div>
                    <div class="col-sm-6">
                        <div class="text-right d-none d-sm-block">
                            All Rights Reserved.
                        </div>
                    </div>
                </div>
            </div>
        </footer>
   <CustomerAddModal @customerDataSaved="customerDataSaved($event)"></CustomerAddModal>
</div>


</template>




<script>
import Vue from "vue";
import CustomerAddModal from "../../components/WarehouseAddModal";
import {mapState, mapActions, mapGetters} from 'vuex';
import axios from "axios";

export default {
    name: "CustomerList",
     components: {
        CustomerAddModal,
    },
    created() {
         if(localStorage.getItem('token')){
             console.log("token "+localStorage.getItem('token'));
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        }
        this.setSuccessMessage(null);
        this.getCustomers();
    },
    data(){
        return {
            bus: new Vue(),
            selected:[],
            options:[
                        // { label: 'Select More Column', id: 0 },
                        { label: 'General phone number', id: 1 },
                        { label: 'Billing email', id: 2 },
                        { label: 'Total number of quotes', id: 3 },
                        { label: 'Total number of orders', id: 4 },
                    ],
            customerData: {
                customers: {
                    data:[]
                },
                config: null,
                can_add_customer: false,
                can_edit_customer: false,
                can_delete_customer: false,
                user_type: null,
                role: null,

            },
            current_page:1,
            per_page:10,
            total:0,
            filterForm: {
                search_filter: null,
                status_filter: ''
            },
            showModal: false,
            deleteId: null,
            csv_file: null,
            uploadPercent: 0,
            showUploadProgress: false,
            processingUpload: false
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setCustomers',
            'setCustomerLoading'
        ]),
        // updatePagination(){
        //     if(this.current_page != 1){
        //         this.getCustomers();
        //     }
        // },
        customerDataSaved(){
            //$('#customerAddModal').modal('hide');
            this.getCustomers();
        },
        getCustomers() {
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('store-warehouse.index',{page: this.current_page,search_filter:this.filterForm.search_filter,status_filter:this.filterForm.status_filter} ), {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    console.log(data);
                    if(data.errors){
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.customerData = data.data;
                         this.current_page = data.data.customers.current_page;
                        this.per_page = data.data.customers.per_page;
                        this.total = data.data.customers.total;
                        //this.setCustomers(data.data);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setCustomerLoading(false);

                });
        },
        getSLNo(index) {
            return Number(this.customerData.config['start_from']) + index;
        },
        handleFileUpload(){
            this.csv_file = this.$refs.csv_file.files[0];
        },
        importFromCsv(){
            let self = this;
            if( this.csv_file){
                this.setCustomerLoading(true);
                this.setCommonErrors([]);
                this.setErrorMessage(null);
                this.showUploadProgress = true;
                this.processingUpload = true;
                this.uploadPercent = 0;
                let formData = new FormData();
                formData.append('csv_file',  this.csv_file);
                axios.post(window.route('customer.importCustomers'), formData, {
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    },
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                    onUploadProgress: (progressEvent) => {
                        this.uploadPercent = progressEvent.lengthComputable ? Math.round( (progressEvent.loaded * 100) / progressEvent.total ) : 0 ;
                    }
                })
                    .then( ({ data }) => {
                        this.showUploadProgress = false;
                        this.processingUpload = false;
                        if(data.errors){
                            self.setCommonErrors(data.errors);
                        } else if(data.errorMessage){
                            self.setErrorMessage(data.errorMessage);
                        } else {
                            self.getCustomers();
                            self.setSuccessMessage(data.data);
                            $('#exportModal').modal('hide');
                        }

                    })
                    .catch( (error) => {
                        self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);
                        this.showUploadProgress = false;
                        this.processingUpload = false;
                    })
                    .finally(() => {
                        self.setCustomerLoading(false);

                    });
            }
        },
        showDelete(id) {
            this.deleteId = id;
            $('#deleteModal').modal('show');
        },
        hideDelete() { $('#deleteModal').modal('hide'); this.deleteId = null; },
        deleteCustomer() {
            if(this.deleteId) {
                let self = this;
                this.setCustomerLoading(true);
                this.setCommonErrors([]);
                this.setErrorMessage(null);
                return axios.delete(window.route('customers.destroy', {id: this.deleteId}), {
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    }
                })
                    .then(({ data }) => {
                        if(data.errors){
                            self.setCommonErrors(data.errors);
                        } else if(data.errorMessage){
                            self.setErrorMessage(data.errorMessage);
                        } else {
                            self.setSuccessMessage(data.data);
                            self.deleteId = null;
                            self.getCustomers();
                            $('#deleteModal').modal('hide');
                        }
                    })
                    .catch((error) => {
                        self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                    })
                    .finally(() => {
                        self.setCustomerLoading(false);

                    });
            }
        }
    },
    watch: {
        current_page: {
        handler: function(value) {

            if(value != 1){
                this.getCustomers();
            }

            console.log("watch ",value);
            // this.fetchData().catch(error => {
            // console.error(error)
            // })
        }
        },

         selected: {
        handler: function(selectedVal) {

            this.getCustomers();

            console.log("watch ",selectedVal);

        }
        }


    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
            'customers',
            'customersLoading'
        ])
    }
}
</script>

<style scoped>
#app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
		margin-top: 60px;
	}
	.select2-selection {
		border-radius: 0px !important;
		text-align: left !important;
	}
	.select2-dropdown {
		border-radius: 0px !important;
	}
</style>

